/* @jsx h */

import { searchType } from '../../config';

const Publication = ({ result }) => {
  return (
    <li className="search-result__item">
      <article className="search-result-item">
        <header className="search-result-item__header">
          {result.contentType && (
            <span className="search-result-item__type">
              {searchType === 'publications'
                ? result.format?.join(', ')
                : result.contentType}
            </span>
          )}
          <h3 className="search-result-item__heading">
            <a className="search-result-item__link" href={result.url}>
              {result.title} {result.subtitle}
            </a>
          </h3>
        </header>
        <div className="search-result-item__content">
          <div className="text-content">
            {result.teaser && <p>{result.teaser}</p>}
            {result.author && (
              <p>
                <strong>{result.authorLabel}</strong>: {result.author}
              </p>
            )}
            {result.editor && (
              <p>
                <strong>{result.editorLabel}</strong>: {result.editor}
              </p>
            )}
            {result.year !== 0 && (
              <p>
                <strong>{result.yearLabel}</strong>: {result.year}
              </p>
            )}
          </div>
        </div>
      </article>
    </li>
  );
};

export default Publication;
